module.exports = __webpack_public_path__ + "static/two-a964ad03e88c18ad36bb848cf944d164.png";